import { E3CreateMacro, J2Multiply } from '@e3dc-react/icons'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Collapse, IconButton, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserSettings } from 'src/Hooks'

interface RetrofitBannerProps {
  installationId: string | undefined
  retrofitTargetSystem: string | undefined
}

const RetrofitBanner: React.FC<RetrofitBannerProps> = ({ installationId, retrofitTargetSystem }) => {
  const { userSettings, updateUserSettings } = useUserSettings()
  const [showRetrofitBanner, setShowRetrofitBanner] = useState(true)
  const { enqueueSuccessStack } = useSnackbar()
  const { t } = useCustomTranslation()
  const navigate = useNavigate()

  const onHideBanner = (): void => {
    if (!installationId) return

    updateUserSettings({ hideRetrofitBanner: [...(userSettings.hideRetrofitBanner ?? []), installationId] }).then(() => {
      enqueueSuccessStack(t('dashboard.retrofit-check.hide.success'))
    })
  }

  const onButtonClick = (): void => {
    if (!retrofitTargetSystem) return

    navigate(`/retrofit-check/${installationId}/${retrofitTargetSystem}`)
  }

  return (
    <Collapse in={showRetrofitBanner} onExited={onHideBanner}>
      <Box>
        <Paper
          title={t('dashboard.retrofit-check.title')}
          headerChildren={
            <IconButton onClick={() => setShowRetrofitBanner(false)}>
              <J2Multiply />
            </IconButton>
          }
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent={'space-between'}
            spacing={2}
            sx={{
              p: 4,
              mt: 2,
              backgroundColor: 'grey.grey07',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'grey.grey06',
            }}
          >
            <Stack direction={'row'} alignItems="center" spacing={2}>
              <E3CreateMacro sx={{ height: 30, width: 30, color: 'primary.main' }} />
              <Typography variant="h4">{t('dashboard.retrofit-check.text')}</Typography>
            </Stack>
            <Button variant="contained" sx={{ whiteSpace: 'nowrap' }} onClick={onButtonClick}>
              {t('dashboard.retrofit-check.button')}
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Collapse>
  )
}

export default RetrofitBanner
